/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 10/5/15.
 */

angular
    .module('prism-ui.components.navigation')
    .service('NavbarUtilService', function (
        this: JS5Object,
        _: JS5Object
    ) {
        this.viewSearchFunction = null;
        this.viewFilterBtnHandler = null;

        this.viewReportButtonHandlers = {
            deliveryReport: null,
            packageMediaReport: null,
            packageReport: null,
            packageMetadataReport: null,
            packageAuditLevelReport: null
        };

        this.searchButtonHandlers = {
            onFindNext: null,
            onFindPrevious: null
        };

        this.searchResultTotal = 0;
        this.currentSearchResultIndex = 0;
        this.showNoResultsMsg = false;

        this.resetSearchResultStats = () => {
            this.searchResultTotal = 0;
            this.currentSearchResultIndex = 0;
            this.showNoResultsMsg = false;
        };

        this.setSearchResultTotal = (searchResultTotal: number) => {
            this.searchResultTotal = searchResultTotal;
        };

        this.setCurrentSearchResultIndex = (currentSearchResultIndex: number) => {
            this.currentSearchResultIndex = currentSearchResultIndex;
        };

        this.setShowNoResultsMsg = (showNoResultsMsg: boolean) => {
            this.showNoResultsMsg = showNoResultsMsg;
        };

        this.clearCurrentSearch = null;

    });
